import { ActionController, ActionControllerEventName } from "@g.frame/common.action_controller";
import { FBX_MODEL, Loader, TEXTURE } from "@g.frame/common.loaders";
import { PickingController, PickingControllerEventNames } from "@g.frame/common.picking_controller";
import { ParentEvent, ViewerModule } from "@g.frame/core";
import { DesktopModule } from "@g.frame/desktop";
import { OculusQuestModule } from "@g.frame/oculus.quest";
import { Euler, Group, Mesh, MeshBasicMaterial, MeshPhongMaterial, PlaneBufferGeometry, Quaternion, Vector3 } from "three";
const wipesConfig = [
    {
        name: 'MODEL_wipes',
        position: new Vector3(2.9, 0.7375, -11.9),
        rotation: new Euler(-Math.PI / 2, 0, 0),
    }
];
export default class WipesComponent extends ViewerModule {
    constructor(modulesProcessor) {
        var _a;
        super();
        this.modulesProcessor = modulesProcessor;
        this.wipes = {};
        this.isVR = false;
        this.wipeActive = false;
        this.loader = this.modulesProcessor.agents.get(Loader);
        this.actionController = this.modulesProcessor.agents.get(ActionController);
        this.pickingController = this.modulesProcessor.agents.get(PickingController);
        this.controls = this.modulesProcessor.modulesInstances.get(DesktopModule)[1];
        this.isVR = !!((_a = this.modulesProcessor.modulesInstances.get(OculusQuestModule)) === null || _a === void 0 ? void 0 : _a.length);
        this.loader.addResources([
            {
                name: 'MODEL_wipes',
                url: require('../../../../assets/models/injection/wipes/wipes.fbx'),
                type: FBX_MODEL
            },
            {
                name: 'TEXTURE_wipes',
                url: require('../../../../assets/textures/injection/wipes.jpg'),
                type: TEXTURE
            },
        ]);
    }
    init() {
        this.initWipes();
    }
    initWipes() {
        const wipesContainer = new Group();
        this.addObject(wipesContainer);
        wipesConfig.forEach(conf => {
            const model = this.loader.getResource(conf.name);
            this.prepareMaterials(model, 0.02);
            model.position.copy(conf.position);
            model.rotation.copy(conf.rotation);
            model.scale.setScalar(1);
            this.wipes[conf.name] = model;
            wipesContainer.add(model);
        });
        this.activeNapkin = this.wipes['MODEL_wipes'].getObjectByName('Napkin018');
    }
    prepareMaterials(syringesContainer, scale) {
        const mat = new MeshPhongMaterial({ map: this.loader.getResource('TEXTURE_wipes') });
        syringesContainer.traverse((child) => {
            if (child.geometry) {
                child.geometry.scale(scale, scale, scale);
            }
            child.position.multiplyScalar(scale);
            if (child.material) {
                child.material = mat;
            }
        });
    }
    initWipeStage() {
        this.activeNapkin.userData = {
            pickingMoveDistance: 1.4,
            pos: this.activeNapkin.position.clone(),
            quat: this.activeNapkin.quaternion.clone(),
        };
        this.wipePlane = new Mesh(new PlaneBufferGeometry(0.5, 0.7).rotateX(Math.PI / 2), new MeshBasicMaterial({ color: '#44ee44', side: 2, transparent: true, opacity: 0.8 }));
        this.wipePlane.position.set(2.64, 0.75, -11.14);
        this.addObject(this.wipePlane);
        const pickingQuaternion = new Quaternion().setFromEuler(new Euler(0, 0, Math.PI / 2));
        this.pickingController.on(PickingControllerEventNames.PICKED, this.activeNapkin, () => {
            this.wipeActive = true;
            this.pickingController.on(PickingControllerEventNames.MOVED, this.activeNapkin, () => {
                if (!this.isVR) {
                    this.activeNapkin.quaternion.copy(pickingQuaternion);
                    this.activeNapkin.updateMatrixWorld(true);
                }
            });
        });
        this.pickingController.on(PickingControllerEventNames.RELEASED, this.activeNapkin, () => {
            this.wipeActive = false;
            this.activeNapkin.position.copy(this.activeNapkin.userData.pos);
            this.activeNapkin.quaternion.copy(this.activeNapkin.userData.quat);
            this.controls.enabled = true;
            this.pickingController.off(PickingControllerEventNames.MOVED, this.activeNapkin);
            //@ts-ignore
            if (this.wipePlane.material.opacity < 0.01) {
                this.pickingController.off(PickingControllerEventNames.RELEASED, this.activeNapkin);
            }
        });
        this.actionController.on(ActionControllerEventName.move, this.wipePlane, () => {
            if (this.wipeActive) {
                //@ts-ignore
                this.wipePlane.material.opacity -= 0.01;
                //@ts-ignore
                if (this.wipePlane.material.opacity < 0.01) {
                    this.pickingController.forceRelease(new Vector3, new Quaternion, false);
                    this.pickingController.off(PickingControllerEventNames.PICKED, this.activeNapkin);
                    this.actionController.off(ActionControllerEventName.move, this.wipePlane);
                    this.removeObject(this.wipePlane);
                    this.fire('wipe_finish', new ParentEvent('wipe_finish'));
                }
            }
        });
    }
    reset() {
        this.pickingController.off(PickingControllerEventNames.PICKED, this.activeNapkin);
        this.pickingController.off(PickingControllerEventNames.RELEASED, this.activeNapkin);
        if (this.wipePlane) {
            this.actionController.off(ActionControllerEventName.move, this.wipePlane);
            this.removeObject(this.wipePlane);
        }
    }
}
